if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 1000));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

     setModelMeasurement(image){           
            var rawDescription = document.querySelector('.product__description');
            var descriptionHeadings = rawDescription.querySelectorAll('h5');            
            descriptionHeadings.forEach(function(element){
            var headingText = element.textContent;
            var spanElement = element.nextElementSibling;
            if(headingText == 'Model Measurements'){
              if(image){
                if(image.indexOf(";") == -1){
                  if(image.indexOf("#") == -1)
                  {
                    spanElement.textContent = $(this).next().text();
                    
                  }
                  else
                  {
                    let stringImage = image.split('#');
                    let stringImageLast = stringImage[stringImage.length-1];
                    spanElement.innerHTML = '<li>'+stringImage[0]+"</li><li>"+stringImageLast+'</li>';
                    
                  }             
      
                }else{
                  if(image.indexOf("#") == -1){  
                    spanElement.innerHTML = '<li>'+image.split('@')[0].split(';')[1]+'</li>';            
                  }else{
                    let stringImageF = (image.split(';')[1]).split('#')[0].split('@')[0];
                    let stringImageL = (image.split(';')[1]).split('#')[1];
                    let showText = '<li>'+stringImageF +"</li><li>" +stringImageL+'</li>';
                    spanElement.innerHTML = showText;
                  }
                }
              }else{
                //$(this).next('li').next('span').text($(this).next().text());
              }
            }
      
            if(headingText == 'Fabric'){
              if(image){
                const regex = /!(.*?)!/g;
                const matches = image.match(regex);
                if (matches) {            
                  const textBetweenExclamationMarks = matches.map(match => match.slice(1, -1));
                  let ulItems = textBetweenExclamationMarks[0].split("^");
                  let ul = $('<ul>');
                  $.each(ulItems, function(index, item) {              
                    var li = $('<li>').text(item);
                    ul.append(li);
                  });
                  spanElement.innerHTML=ul.html();
                }
      
              }
            }
        });
      }
      
      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        if(!activeMedia.getAttribute('data-alt').includes("Gift Card")){
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');
        this.setModelMeasurement(activeMedia.getAttribute('data-alt'));
        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
            activeMedia.scrollIntoView({ behavior: 'smooth' });
          }
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }
    }
      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
